import React from 'react'
import ReactDOMClient from 'react-dom/client'
import singleSpaReact from 'single-spa-react'
import App from './App'

import * as Sentry from '@sentry/react'

if (import.meta.env.VITE_ENV === 'production' || import.meta.env.VITE_ENV === 'staging') {
  Sentry.init({
    dsn: 'https://982d87095043e2bff9f0ca40ead074c8@o4504645373001728.ingest.sentry.io/4506157441679360',
    integrations: [Sentry.browserTracingIntegration(), Sentry.replayIntegration()],
    environment: import.meta.env.VITE_ENV,
    tracesSampleRate: 0.01,
    sampleRate: 0.2,
    replaysSessionSampleRate: 0.01,
    replaysOnErrorSampleRate: 1.0,
    ignoreErrors: [/ResizeObserver loop.*/],
    tracePropagationTargets: [
      /^\/(?!\/)/, // Relative URLs
      // Include .instaleap.io domains EXCEPT Stytch domains
      /^(?!stytch(-staging)?\.instaleap\.io$).*\.instaleap\.io$/
    ]
  })
}

const reactLifecycles = singleSpaReact({
  React,
  ReactDOMClient,
  rootComponent: App,
  errorBoundary(err) {
    return (
      <div>
        <h2>Something went wrong in the microfrontend.</h2>
        <pre>{err?.message}</pre>
      </div>
    )
  },
  domElementGetter
})

export const bootstrap = [reactLifecycles.bootstrap]

export const mount = [reactLifecycles.mount]

export const unmount = [reactLifecycles.unmount]

function domElementGetter() {
  return document.getElementById('root')
}
